<template>
  <div class="d-flex justify-content-center flex-wrap mt-3">
    <div class="col-12 text-center">
      <b-img :src="emptyStateImage" class="img-empty-campaign mb-3"></b-img>
    </div>
  </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'

export default {
  name: 'CampaignEmptyState',
  components: {
    BImg
  },
  data() {
    return {
      emptyStateImage: require('@/assets/images/elements/campaign/campanas.png')
    }
  }
}
</script>

<style scoped lang="scss">
.img-empty-campaign {
  max-width: 600px;
  width: 100%;
  height: auto;
  margin: 0 auto;
}
</style>
